import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

/**
 * SEO Footer - internal links to all high-value pages
 * Google crawls footer links, boosts those pages
 */
export function SeoFooter({ darkMode }) {
  const links = [
    { to: '/sarkari-result', label: 'Sarkari Result' },
    { to: '/sarkari-result-check', label: 'Sarkari Result Check' },
    { to: '/latest-sarkari-result', label: 'Latest Sarkari Result' },
    { to: '/sarkari-naukri', label: 'Sarkari Naukri' },
    { to: '/up-police-result', label: 'UP Police Result' },
    { to: '/ssc-result', label: 'SSC Result' },
    { to: '/railway-result', label: 'Railway Result' },
    { to: '/upsc-result', label: 'UPSC Result' },
    { to: '/bank-jobs', label: 'Bank Jobs' },
    { to: '/results', label: 'Sarkari Exam Result' },
    { to: '/admit-card', label: 'Admit Card' },
    { to: '/answer-key', label: 'Answer Key' },
    { to: '/', label: 'Home' },
  ];
  return (
    <footer className={`mt-auto border-t py-6 ${darkMode ? 'border-gray-700 bg-gray-900' : 'border-gray-200 bg-white'}`}>
      <div className="max-w-6xl mx-auto px-4">
        <p className={`text-center text-xs mb-3 px-2 ${darkMode ? 'text-amber-200/90' : 'text-amber-800'}`}>
          <strong>Disclaimer:</strong> This website is for informational purposes only. For accurate and official information, please refer to the respective official government websites and recruitment portals.
        </p>
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm">
          {links.map(({ to, label }) => (
            <RouterLink key={to} to={to} className={`font-medium hover:underline ${darkMode ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-sarkari-red'}`}>
              {label}
            </RouterLink>
          ))}
        </div>
        <p className={`text-center text-xs mt-3 ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>
          © 2026 Sarkariresult.cloud – Sarkari Result 2026 | Sarkariresult | Sarkari Naukri | Govt Jobs | SSC, Railway, UPSC Result
        </p>
      </div>
    </footer>
  );
}
